import { createSlice } from "@reduxjs/toolkit";

export const liveCasinoSlice = createSlice({
  name: "liveCasino",
  // initialState: null,
  initialState: {
    allGames: [],
    tabs: [],
  },
  reducers: {
    getLiveCasinoSuccess: (state, action) => ({
      ...state,
      allGames: action.payload,
    }),
    getGapCasinoSuccess: (state, action) => ({
      ...state,
      gapCasinoGame: action.payload,
    }),
    getLiveCasinoError: (state) => ({ ...state, allGames: [] }),
    getGapCasinoError: (state) => ({ ...state, gapCasinoGame: [] }),

    setLiveCasinoTabs: (state, action) => ({ ...state, tabs: action.payload }),

    getLiveCasinoIDSuccess: (state, action) => ({
      ...state,
      liveCasinoID: action.payload,
    }),
    getLiveCasinoIDError: (state) => state,

    allGames: (state, action) => ({ ...state, allGames: action.payload }),
    topGames: (state, action) => ({ ...state, topGames: action.payload }),
    liveGames: (state, action) => ({ ...state, liveGames: action.payload }),
    tableGames: (state, action) => ({ ...state, tableGames: action.payload }),
    pokerGames: (state, action) => ({ ...state, pokerGames: action.payload }),
    blackjackGames: (state, action) => ({
      ...state,
      blackjackGames: action.payload,
    }),
    baccaratGames: (state, action) => ({
      ...state,
      baccaratGames: action.payload,
    }),
    rouletteGames: (state, action) => ({
      ...state,
      rouletteGames: action.payload,
    }),
    showsGames: (state, action) => ({ ...state, showsGames: action.payload }),
    virtualGames: (state, action) => ({
      ...state,
      virtualGames: action.payload,
    }),
  },
});

export const {
  getLiveCasinoSuccess,
  getLiveCasinoError,
  setLiveCasinoTabs,
  getLiveCasinoIDSuccess,
  getLiveCasinoIDError,
  allGames,
  topGames,
  liveGames,
  tableGames,
  pokerGames,
  blackjackGames,
  baccaratGames,
  rouletteGames,
  showsGames,
  getGapCasinoSuccess,
  virtualGames,
  getGapCasinoError,
} = liveCasinoSlice.actions;

export default liveCasinoSlice.reducer;
